import React from 'react'

export default ({children}) =>
  <div className="wrapper-page">
    {children}
  </div>



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/DefaultLayout.js